// const { $ } = require("video.js/dist/types/utils/dom");

var isRTL = $("html").attr("dir") == "rtl" ? true : false,
  winWidth = $(window).width(),
  winHeight = $(window).height();
var lang = $("html").attr("lang") || "en";

$(function () {
  browserDetect();
});

$(window).on("resize orientationchange", function () {
  // Do on resize
  (winWidth = $(window).width()), (winHeight = $(window).height());
});

$(window).on("scroll", function () {
  //Do on Scroll
});

$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    //Do on ESC press
  }
});

function browserDetect() {
  navigator.sayswho = (function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join("").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  })();
  $("body").addClass(navigator.sayswho);
}

$(document).ready(function () {
  // animateWords();
  checkIOS();
  detectPointerType();
  dataTrim();
  ChangeToSvg();
  formValidation();
  cultureSlider();
  menuOpen();
  scrollTop();
  initSmoothScroll();
  showCookie();
  twoColSlider(false, false, 5000);
  $(window).on("load", function () {
    setTimeout(function () {
      // stickVideoAnimation();
      observeVideoPause();
      revealAnimation();
      initMapCanvas();
      setTimeout(function () {
        AOS.init();
        initializeAccordian();
      }, 200);
    }, 200);
  });
});

function dataTrim() {
  var ellipsis = "...";
  $("[data-trim]").each(function () {
    var text = $(this).html();
    var charLimit = parseInt($(this).attr("data-trim"));
    $(this).html(TrimLength(text, charLimit));
    $(this).addClass("is--trimmed");
  });

  function TrimLength(text, maxLength) {
    text = $.trim(text);
    if (text.length > maxLength) {
      text = text.substring(0, maxLength - ellipsis.length);
      return text.substring(0, text.lastIndexOf(" ")) + ellipsis;
    } else return text;
  }
}

function ChangeToSvg() {
  $("img.js-tosvg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        var $svg = $(data).find("svg");
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " insvg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}

// Form Field Validation Start

function formValidation() {
  const submitBtn = document.querySelectorAll(".Formsubmit");

  // Loop through each submit button
  submitBtn.forEach(function (button) {
    button.addEventListener("click", function (event) {
      var form = event.target.closest("form"); // Get the parent form of the clicked button
      var isValid = true;

      $(form)
        .find(".form-row-dropdown, .form-fields-row")
        .each(function () {
          var $select = $(this).find("select");
          var $errorMessage = $(this).find(".error");
          var $select2Container = $(this).find(".select2-container");

          if ($select.val() == null || $select.val() == "1") {
            isValid = false;
            $select2Container.addClass("error-border");
            $errorMessage.show();
          } else {
            $select2Container.removeClass("error-border");
            $errorMessage.hide();
          }
        });

      // Check input fields with the required class within the current form
      $(form)
        .find(".required")
        .each(function () {
          if ($(this).val().trim() === "") {
            isValid = false;
            $(this).addClass("error-border");
            $(this).siblings(".error").show();
          } else {
            $(this).removeClass("error-border");
            $(this).siblings(".error").hide();
          }
        });

      if (!isValid) {
        event.preventDefault(); // Prevent form submission if validation fails
      }
    });
  });

  //
  var togglePasswordIcons = document.querySelectorAll(".eye-icon");
  var togglePasswordSlashIcons = document.querySelectorAll(".eye-slash-icon");

  togglePasswordIcons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      togglePasswordVisibility(icon);
    });
  });

  togglePasswordSlashIcons.forEach(function (Slashicon) {
    Slashicon.addEventListener("click", function () {
      togglePasswordVisibility(Slashicon);
    });
  });

  function togglePasswordVisibility(clickedIcon) {
    var passwordField = clickedIcon.parentNode.querySelector(".password-field");
    var relatedIcon = clickedIcon.classList.contains("eye-icon")
      ? clickedIcon.nextElementSibling
      : clickedIcon.previousElementSibling;

    if (passwordField.type === "password") {
      passwordField.type = "text";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    } else {
      passwordField.type = "password";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    }
  }
}

// --------------------- Accordion Start -------------------------
const initializeAccordian = () => {
  $(".accordion").each(function () {
    const $group = $(this);
    if ($group.find(".accordion-item.open").length === 0) {
      const firstItem = $group.find(".accordion-item").first();
      firstItem.addClass("open");
      firstItem.find(".accordion-content").show().addClass("animate");
    }

    $group.find(".accordion-header").click(function () {
      const $clickedItem = $(this).parent(".accordion-item");
      const $clickedContent = $(this).next(".accordion-content");

      if ($clickedItem.hasClass("open")) {
        // Close it
        $clickedItem.removeClass("open");
        $clickedContent.removeClass("animate").slideUp();
        $clickedItem.removeClass("active");
        return;
      }

      // Close all items
      $group.find(".accordion-item").removeClass("open");
      $group.find(".accordion-content").each(function () {
        $(this).removeClass("animate").slideUp();
      });
      $group.find(".accordion-item").removeClass("active");

      // Open the clicked one
      $clickedItem.addClass("open");
      $clickedContent.slideDown(function () {
        $(this).addClass("animate");
      });
    });
  });
};

// --------------------- Accordion End -------------------------

// Decimal Counter - .count
const counterElements = document.querySelectorAll(".count");
const speed = 60; // Lower = Slower

function runDecimalCounter(target, start, stop) {
  target.innerText = start.toFixed(1);
  const counterInterval = setInterval(() => {
    const increment = stop / speed;
    start += increment;
    const roundedValue = (Math.round(start * 10) / 10).toFixed(1);
    target.innerText = roundedValue;

    if (parseFloat(roundedValue) >= parseFloat(stop)) {
      target.innerText = parseFloat(stop).toFixed(1);
      clearInterval(counterInterval);
    }
  }, 30);
}

const observerDecimal = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const target = entry.target;
      const stop = parseFloat(
        target.getAttribute("data-target") || target.innerText
      );
      runDecimalCounter(target, 0, stop);
      observer.unobserve(target);
    });
  },
  { threshold: 1 }
);

counterElements.forEach((el) => observerDecimal.observe(el));

// Integer Counter with Commas - .counterup
const counterUpElements = document.querySelectorAll(".counterup");

const observerInteger = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;

    const el = entry.target;
    const stop = parseInt(
      el.getAttribute("data-target") || el.innerText.replace(/,/g, ""),
      10
    );
    let start = 0;
    const duration = 1500;
    const startTime = performance.now();

    function updateCounter(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const current = Math.floor(progress * stop);
      el.innerText = current.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        el.innerText = stop.toLocaleString();
      }
    }

    requestAnimationFrame(updateCounter);
    observer.unobserve(el);
  });
});

counterUpElements.forEach((el) => observerInteger.observe(el));

// Draw Map Selection Canvas Start
function initMapCanvas() {
  const mapCanvas = document.querySelector(".md-canvas-wrapper");

  if (mapCanvas) {
    // Create a temporary DOM element to manipulate the innerHTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = mapCanvas.innerHTML;

    // Remove all attributes starting with 'data-aos-' and 'type'
    tempDiv.querySelectorAll("*").forEach((el) => {
      // Remove 'data-aos-*' attributes
      [...el.attributes].forEach((attr) => {
        if (
          attr.name.startsWith("data-aos-") ||
          attr.name === "data-aos" ||
          attr.name === "type"
        ) {
          el.removeAttribute(attr.name);
        }
      });
    });

    // Get cleaned HTML
    var mapCanvasCopy = tempDiv.innerHTML;

    let prevWidth = $(window).width();
    let resizeTimeout;

    $(window).on("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentWidth = $(window).width();
        if (currentWidth !== prevWidth) {
          prevWidth = currentWidth;
          document.querySelector(".md-canvas-wrapper").innerHTML =
            mapCanvasCopy;
          if (window.customVariables.CanvasBg) {
            drawMapCanvas();
          }
        }
      }, 500);
    });
    if (window.customVariables.CanvasBg) {
      drawMapCanvas();
    }
  }
  function drawMapCanvas() {
    const canvas = new fabric.Canvas("js-map-canvas", {
      selection: false,
      allowTouchScrolling: true,
    });
    canvas.allowTouchScrolling = true;
    const $tooltip = $("#js-canvas-tooltip");
    const $tooltipText = $("#js-canvas-tooltip-txt");
    const $CanvasTitle = $("#js-canvas-title");
    const $CanvasEl = $("#js-map-canvas");
    const CanvasBG = window.customVariables.CanvasBg;
    const tooltipTextValue = window.customVariables.CanvasText;
    const $wrapper = $(".md-canvas-wrapper");
    const remToPx = (rem) => rem * parseFloat($("html").css("font-size"));

    const pins = [
      {
        x: 0.490,
        y: 0.572,
        id: 1,
        circleX: 0.485,
        circleY: 0.61,
        circleTransform: "rotate(3)",
        circleRx: 270,
        circleRy: 92,
        backgroundColorPin: "#FF666C",
        backgroundColorTooltip: "#E34247",
        TextColorTooltip: "#FFFFFF",
      },
      {
        x: 0.365,
        y: 0.63,
        id: 2,
        circleX: 0.352,
        circleY: 0.67,
        circleTransform: "rotate(-5)",
        circleRx: 390,
        circleRy: 116,
        backgroundColorPin: "#CCF07F",
        backgroundColorTooltip: "#CCF07F",
        TextColorTooltip: "#354E04",
      },
      {
        x: 0.51,
        y: 0.73,
        id: 3,
        circleX: 0.5,
        circleY: 0.8,
        circleTransform: "rotate(0.5)",
        circleRx: 450,
        circleRy: 275,
        backgroundColorPin: "#34B78F",
        backgroundColorTooltip: "#34B78F",
        TextColorTooltip: "#FFFFFF",
      },
      {
        x: $(window).width() >= 1024 ? 0.675 : 0.65,
        y: $(window).width() >= 1024 ? 0.655 : 0.66,
        id: 4,
        circleX: 0.678,
        circleY: 0.695,
        circleTransform: "rotate(12)",
        circleRx: 470,
        circleRy: 145,
        backgroundColorPin: "#DA94FF",
        backgroundColorTooltip: "#DA94FF",
        TextColorTooltip: "#60288A",
      },
      {
        x: 0.645,
        y: 0.575,
        id: 5,
        circleX: 0.645,
        circleY: 0.615,
        circleTransform: "rotate(1.5)",
        circleRx: 265,
        circleRy: 80,
        backgroundColorPin: "#00D393",
        backgroundColorTooltip: "#228848",
        TextColorTooltip: "#FFFFFF",
      },
    ].map((pin, index) => ({
      ...pin,
      text: tooltipTextValue[index][lang] || `ToolTip# ${pin.id}`,
    }));

    const pinSVG = `
       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="68" viewBox="0 0 40 68" fill="none">
         <path d="M20.1355 41.6579L15.7411 34.3352L15.7442 34.329L20.1447 26.997L20.1524 27.0124L24.5467 34.3352L24.5437 34.3414L20.1447 41.6734L20.1355 41.6579ZM20.1447 18.6367L10.7266 34.3352L20.1447 50.0321L29.5629 34.3352L20.1447 18.6367Z" fill="{COLOR}"/>
         <path d="M31.5098 34.4053L19.8818 53.7842L8.25391 34.4053L19.8818 15.0244L31.5098 34.4053Z" stroke="{COLOR}" stroke-width="1.59468"/>
         <path d="M35.5469 34.2334L19.8848 60.3389L4.22168 34.2334L19.8848 8.12695L35.5469 34.2334Z" stroke="{COLOR}" stroke-width="0.956811"/>
         <path d="M39.5811 34.0596L19.8838 66.8896L0.185547 34.0596L19.8838 1.22754L39.5811 34.0596Z" stroke="{COLOR}" stroke-width="0.318937"/>
       </svg>`;

    let backgroundImage = null;
    let pinObjects = [];
    let ellipseObjects = [];
    let backgroundImageSet = false;
    let currentPinObj = null;
    let previousActivePinId = null;
    function resizeCanvas() {
      canvas.setWidth(window.innerWidth);
      const width = window.innerWidth; // Use innerWidth instead of outerWidth
      const height = window.innerHeight;

      if (width >= 1920) {
        canvas.setHeight(Math.max(width / 2, Math.min(height, 2000)));
      } else if (width >= 1200) {
        canvas.setHeight(Math.max(800, Math.min(height, 1000)));
      } else if (width >= 768) {
        canvas.setHeight(remToPx(64)); // remToPx must be defined
      } else {
        canvas.setHeight(remToPx(42));
      }

      imageAlignment = "center";
      if ($(window).width() <= 550) {
        imageScaleMode = remToPx(0.0135);
      } else if ($(window).width() <= 768) {
        imageScaleMode = 0.4;
      } else if ($(window).width() <= 830) {
        imageScaleMode = 0.4;
      } else if ($(window).width() <= 1280) {
        imageScaleMode = 0.4;
      } else if ($(window).width() <= 1440) {
        imageScaleMode = 0.45;
      } else {
        imageScaleMode = "cover";
        imageAlignment = "bottom-left";
      }

      updateBackground(false);
      setTimeout(() => {
        placeHeadingOnCanvas();
      }, 300);
    }

    function getImageOffsets(
      alignment,
      imgWidth,
      imgHeight,
      scale,
      canvasW,
      canvasH
    ) {
      const scaledW = imgWidth * scale;
      const scaledH = imgHeight * scale;
      let SpaceHorizontal = 0;
      let SpaceVertically = 0;

      if ($(window).width() <= 550) {
        SpaceHorizontal = -remToPx(0.6);
        SpaceVertically = -remToPx(1.6);
      } else if ($(window).width() <= 768) {
        SpaceHorizontal = -remToPx(2);
        SpaceVertically = -remToPx(6);
      } else if ($(window).width() <= 830) {
        SpaceHorizontal = -remToPx(1.5);
        SpaceVertically = -remToPx(2);
      } else if ($(window).width() <= 1280) {
        SpaceHorizontal = remToPx(10);
        SpaceVertically = -remToPx(13);
      } else if ($(window).width() <= 1440) {
        SpaceHorizontal = remToPx(10);
        SpaceVertically = -remToPx(18);
      } else {
        SpaceHorizontal = 0;
        SpaceVertically = -remToPx(10);
      }

      const alignments = {
        "top-left": [0, 0],
        top: [(canvasW - scaledW) / 2, 0],
        "top-right": [canvasW - scaledW, 0],
        left: [0, (canvasH - scaledH) / 2],
        center: [
          (canvasW - scaledW) / 2 + SpaceHorizontal,
          (canvasH - scaledH) / 2 + SpaceVertically,
        ],
        right: [canvasW - scaledW, (canvasH - scaledH) / 2],
        "bottom-left": [0, canvasH - scaledH],
        bottom: [(canvasW - scaledW) / 2, canvasH - scaledH],
        "bottom-right": [
          canvasW - scaledW + (window.innerWidth <= 500 ? 120 : 0),
          canvasH - scaledH,
        ],
        "bottom-center": [
          (canvasW - scaledW) / 2 - SpaceHorizontal,
          canvasH - scaledH + SpaceVertically,
        ],
      };

      return alignments[alignment] || alignments["center"];
    }

    function updateBackground(fade = false) {
      if (backgroundImageSet) return;

      const url = CanvasBG;

      if (!url) return;

      const canvasW = canvas.getWidth();
      const canvasH = canvas.getHeight();

      fabric.Image.fromURL(url, (newImage) => {
        const imgW = newImage.width;
        const imgH = newImage.height;

        let customScale = 1;

        const scale = (() => {
          if (typeof imageScaleMode === "number") return imageScaleMode;

          const imgRatio = newImage.width / newImage.height;
          const canvasRatio = canvasW / canvasH;

          if (imageScaleMode === "cover") {
            return Math.max(
              canvasW / newImage.width,
              canvasH / newImage.height
            );
          } else if (imageScaleMode === "contain") {
            return Math.min(
              canvasW / newImage.width,
              canvasH / newImage.height
            );
          } else if (imageScaleMode === "custom") {
            return customScale;
          }

          return 1;
        })();

        const [offsetX, offsetY] = getImageOffsets(
          imageAlignment,
          imgW,
          imgH,
          scale,
          canvasW,
          canvasH
        );

        newImage.scale(scale);
        newImage.set({
          left: offsetX,
          top: offsetY,
          opacity: fade ? 0 : 1,
          selectable: true,
          evented: false,
        });

        if (!fade) {
          canvas.setBackgroundImage(newImage, () => {
            backgroundImage = newImage;
            canvas.renderAll();
            renderPins();
          });
          return;
        }

        canvas.setBackgroundImage(newImage, () => {
          backgroundImage = newImage;
          canvas.renderAll();
          renderPins();
          backgroundImageSet = true;
        });
      });
    }

    function placeHeadingOnCanvas() {
      const canvasOffset = $wrapper.offset();
      const canvasHeight = $wrapper.innerHeight();
      let spacebottom;

      if (window.innerWidth <= 992) {
        spacebottom = 0;
      } else if (window.innerWidth <= 1280) {
        spacebottom = 3.75;
      } else if (window.innerWidth <= 1440) {
        spacebottom = 4.44;
      } else {
        spacebottom = 5;
      }
      if (isRTL) {
        $CanvasTitle.css({
          position: "absolute",
          right: canvasOffset.left,
          top:
            window.innerWidth <= 992
              ? 0
              : canvasHeight -
              $CanvasTitle.outerHeight() -
              remToPx(spacebottom),
        });
      } else {
        $CanvasTitle.css({
          position: "absolute",
          left: canvasOffset.left,
          top:
            window.innerWidth <= 992
              ? 0
              : canvasHeight -
              $CanvasTitle.outerHeight() -
              remToPx(spacebottom),
        });
      }
    }

    function createGlowEllipses(pin, ellipsePinX, ellipsePinY) {
      const glowEllipses = [];

      for (let i = 8; i >= 1; i--) {
        glowEllipses.push(
          new fabric.Ellipse({
            left: ellipsePinX,
            top: ellipsePinY,
            originX: "center",
            originY: "center",
            rx: pin.circleRx * (1 + 0.02 * i),
            ry: pin.circleRy * (1 + 0.02 * i),
            fill: "#000",
            opacity: 0.02 * i,
            selectable: false,
            evented: false,
            objectCaching: false,
          })
        );
      }

      return glowEllipses;
    }

    function renderPins() {
      pinObjects.forEach((obj) => canvas.remove(obj));
      pinObjects = [];
      ellipseObjects.forEach((obj) => canvas.remove(obj));
      ellipseObjects = [];

      const scale = backgroundImage.scaleX;
      const imgLeft = backgroundImage.left;
      const imgTop = backgroundImage.top;

      pins.forEach((pin, index) => {
        const pinX = imgLeft + pin.x * backgroundImage.width * scale;
        const pinY = imgTop + pin.y * backgroundImage.height * scale;
        const ellipsePinX =
          imgLeft + pin.circleX * backgroundImage.width * scale;
        const ellipsePinY =
          imgTop + pin.circleY * backgroundImage.height * scale;
        const ellipseScale = 1 * scale;

        const glowEllipses = createGlowEllipses(pin, ellipsePinX, ellipsePinY);
        const mainEllipse = new fabric.Ellipse({
          left: ellipsePinX,
          top: ellipsePinY,
          originX: "center",
          originY: "center",
          rx: pin.circleRx,
          ry: pin.circleRy,
          fill: "transparent",
          selectable: false,
          evented: false,
        });

        const ellipseGroup = new fabric.Group([...glowEllipses, mainEllipse], {
          left: ellipsePinX,
          top: ellipsePinY,
          originX: "center",
          originY: "center",
          scaleX: ellipseScale,
          scaleY: ellipseScale,
          selectable: false,
          evented: false,
        });

        ellipseGroup.pinId = pin.id;

        if (pin.circleTransform) {
          const rotateMatch = pin.circleTransform.match(/rotate\(([-\d.]+)\)/);
          if (rotateMatch) {
            const angle = parseFloat(rotateMatch[1]);
            ellipseGroup.rotate(angle);
          }
        }

        ellipseObjects.push(ellipseGroup);
        canvas.add(ellipseGroup);
        canvas.sendToBack(ellipseGroup);

        const pinSvgString = pinSVG.replaceAll(
          "{COLOR}",
          pins[index % pins.length].backgroundColorPin || "#ffffff"
        );

        fabric.loadSVGFromString(pinSvgString, (objects, options) => {
          const group = fabric.util.groupSVGElements(objects, options);
          group.set({
            left: pinX,
            top: pinY,
            originX: "center",
            originY: "center",
            selectable: false,
            hoverCursor: "pointer",
          });
          group.scale(window.innerWidth < 768 ? 0.7 : (window.innerWidth < 1300?  1 : 1.2));
          group.pinData = pin;

          if (currentPinObj && currentPinObj.pinData.id === pin.id) {
            group.set("visible", false);
          }

          pinObjects.push(group);
          canvas.add(group);
          canvas.renderAll();

          if (index === 0 && !currentPinObj) {
            setTimeout(() => {
              showTooltipForPin(group);
            }, 50);
          }

          const floatAmplitude = 4;
          const floatSpeed = 0.002;
          const originalTop = group.top;
          const phaseOffset = Math.random() * 2 * Math.PI;

          let startTime = Date.now();

          const float = () => {
            const now = Date.now();
            const elapsed = now - startTime;

            const angle = elapsed * floatSpeed + phaseOffset;
            const offsetY = Math.sin(angle) * floatAmplitude;

            group.top = originalTop + offsetY;
            canvas.requestRenderAll();

            requestAnimationFrame(float);
          };

          float();
        });
      });
    }

    function fabricPointToPageCoords(point) {
      const canvasOffset = $(canvas.upperCanvasEl).offset();

      return {
        x: $(canvas.upperCanvasEl).offset().left + point.x,
        y: $(canvas.upperCanvasEl).offset().top + point.y,
      };
    }

    function showTooltipForPin(pinObj) {
      pinObjects.forEach((pin) => {
        if (pin !== pinObj) {
          pin.set({
            visible: true,
            opacity: 1,
          });
        }
      });

      ellipseObjects.forEach((ellipseGroup) => {
        const isCurrent = ellipseGroup.pinId === pinObj.pinData.id;
        const wasPreviouslyActive = ellipseGroup.pinId === previousActivePinId;
        const isDeactivating =
          wasPreviouslyActive && ellipseGroup.pinId !== pinObj.pinData.id;

        ellipseGroup._objects.forEach((ellipse, i) => {
          const isMain = i === ellipseGroup._objects.length - 1;
          const glowLayerIndex = 8 - i;

          // === CASE 1: CURRENTLY ACTIVE PIN ===
          if (isCurrent) {
            if (isMain) {
              ellipse.set({
                fill: "rgba(0, 0, 0, 0.0)",
                stroke: "rgba(0, 0, 0, 0)",
                strokeWidth: 5,
                opacity: 1,
                scaleX: 1,
                scaleY: 1,
                shadow: new fabric.Shadow({
                  color: "rgba(227, 66, 71, 0)",
                  blur: 30,
                  offsetX: 0,
                  offsetY: 0,
                  affectStroke: true,
                }),
              });
              canvas.bringToFront(ellipse);
            } else {
              if (ellipseGroup.pinId !== previousActivePinId) {
                ellipse.set({
                  opacity: 0,
                  stroke: null,
                  fill: "rgba(255, 255, 255, 0.05)",
                  scaleX: 0.2,
                  scaleY: 0.2,
                  shadow: null,
                });

                const targetOpacity = 0.02 * glowLayerIndex;
                const delay = glowLayerIndex * 10;
                const duration = 500;

                fabric.util.animate({
                  startValue: 0,
                  endValue: targetOpacity,
                  duration: duration,
                  delay: delay,
                  onChange(value) {
                    ellipse.set("opacity", value);
                    canvas.requestRenderAll();
                  },
                });

                fabric.util.animate({
                  startValue: 0.2,
                  endValue: 1,
                  duration: duration,
                  delay: delay,
                  onChange(value) {
                    ellipse.set({
                      scaleX: value,
                      scaleY: value,
                    });
                    canvas.requestRenderAll();
                  },
                });
              } else {
                // Already active - keep static
                ellipse.set({
                  opacity: 0.02 * glowLayerIndex,
                  stroke: null,
                  fill: "rgba(255, 255, 255, 0.05)",
                  scaleX: 1,
                  scaleY: 1,
                  shadow: null,
                });
              }
            }

            // === CASE 2: PREVIOUSLY ACTIVE PIN NOW DEACTIVATING ===
          } else if (isDeactivating) {
            if (isMain) {
              ellipse.set({
                shadow: null,
                stroke: null,
              });

              fabric.util.animate({
                startValue: 1,
                endValue: 0,
                duration: 500,
                onChange(value) {
                  ellipse.set({
                    scaleX: value,
                    scaleY: value,
                    opacity: 0,
                  });
                  canvas.requestRenderAll();
                },
                onComplete() {
                  ellipse.set({
                    fill: "transparent",
                    scaleX: 1,
                    scaleY: 1,
                    opacity: 1,
                  });
                  canvas.requestRenderAll();
                },
              });
            } else {
              fabric.util.animate({
                startValue: 0.8,
                endValue: 1,
                duration: 300,
                // delay: glowLayerIndex * 0.2,
                easing: fabric.util.ease.linear,
                onChange(value) {
                  ellipse.set({
                    fill: "#000",
                    scaleX: value,
                    scaleY: value,
                    opacity: value * 0.02 * glowLayerIndex,
                  });
                  canvas.requestRenderAll();
                },
                onComplete() {
                  ellipse.set({
                    fill: "#000",
                    scaleX: 1,
                    scaleY: 1,
                    opacity: 0.02 * glowLayerIndex,
                  });
                  canvas.requestRenderAll();
                },
              });
            }

            // === CASE 3: STATIC NON-INTERACTED ELLIPSES ===
          } else {
            if (isMain) {
              ellipse.set({
                fill: "transparent",
                stroke: null,
                strokeWidth: 0,
                opacity: 1,
                scaleX: 1,
                scaleY: 1,
                shadow: null,
              });
            } else {
              ellipse.set({
                fill: "#000",
                stroke: null,
                strokeWidth: 0,
                opacity: 0.02 * glowLayerIndex,
                scaleX: 1,
                scaleY: 1,
                shadow: null,
              });
            }
          }
        });
      });

      // Update previous active pin for next cycle
      previousActivePinId = pinObj.pinData.id;

      canvas.requestRenderAll();
      currentPinObj = pinObj;

      fabric.util.animate({
        startValue: 1,
        endValue: 0,
        duration: 450,
        onChange: function (value) {
          pinObj.set("opacity", value);
          canvas.requestRenderAll();
        },
        onComplete: function () {
          pinObj.set({ visible: false });
          canvas.requestRenderAll();
        },
      });

      const center = pinObj.getCenterPoint();
      const pos = fabricPointToPageCoords(center);

      $tooltipText.html(pinObj.pinData.text || "Nan");
      $tooltipText.css({ color: pinObj.pinData.TextColorTooltip || "#ffffff" });
      $tooltip.find("div").css({
        backgroundColor: pinObj.pinData.backgroundColorTooltip || "#000000",
      });
      const targetLeft = pos.x - $CanvasEl.offset().left - $tooltip.outerWidth() / 2;
      const targetTop = pos.y - $CanvasEl.offset().top - (window.innerWidth <= 480? remToPx(4.5) : 85);
      const startTop = targetTop + 10;

      $tooltip
        .css({
          left: targetLeft + "px",
          top: startTop + "px",
          position: "absolute",
          pointerEvents: window.outerWidth < 1400 ? "none" : "auto",
          userSelect: "text",
          opacity: 0,
          display: "block",
          scale: 1,
        })
        .stop(true, true)
        .animate(
          {
            top: targetTop + "px",
            opacity: 1,
          },
          600,
          "swing",
          function () {
            $(".canvas-container").css({ pointerEvents: "all" });
          }
        );
    }

    if (isTouchDevice) {
      $(".canvas-container").addClass("paused");

      mapCanvas.addEventListener("touchstart", function () {
        $(".canvas-container").removeClass("paused");
        setTimeout(function () {
          $(".canvas-container").addClass("paused");
        }, 500);
      });
    }

    canvas.on("mouse:down", function (options) {
      if (options.target && options.target.pinData) {
        $(".canvas-container").css({ pointerEvents: "none" });
        const pinObj = options.target;
        currentImageId = pinObj.pinData.id;

        firstTooltipShown = true;
        showTooltipForPin(pinObj);
      } else {
        canvas.renderAll();
      }
    });

    resizeCanvas();
  }
}
// Draw Map Selection Canvas End

$(document).ready(function () {
  $(".riyad--routed").on("init", function (event, slick) {
    setTimeout(function () {
      var dotsWidth = $(".riyad-dots").width() + 8;
      $(".riyad-dots").css("width", dotsWidth + "px");
    }, 50);
  });
  $(".riyad--routed").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    centerPadding: "15.4rem",
    centerMode: true,
    autoplay: false,
    rtl: isRTL,
    autoplaySpeed: 3000,
    prevArrow: $(".riyad-slider-prev"),
    nextArrow: $(".riyad-slider-next"),
    dots: true,
    appendDots: $(".riyad-dots"),
    responsive: [
      {
        breakpoint: 1681,
        settings: {
          centerPadding: "10.61rem",
        },
      },
      {
        breakpoint: 1281,
        settings: {
          centerPadding: "10rem",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "8.1rem",
        },
      },
      {
        breakpoint: 601,
        settings: {
          centerPadding: "3rem",
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".bluePrint-slider").on("init", function (event, slick) {
    setTimeout(function () {
      var dotsWidth = $(".bluePrint-dots").width() + 8;
      $(".bluePrint-dots").css("width", dotsWidth + "px");
    }, 50);
  });

  $(".bluePrint-slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    centerPadding: "15.4rem",
    centerMode: true,
    autoplay: false,
    autoplaySpeed: 3000,
    rtl: isRTL,
    dots: true,
    appendDots: $(".bluePrint-dots"),
    prevArrow: $(".bluePrint-prev"),
    nextArrow: $(".bluePrint-next"),
    responsive: [
      {
        breakpoint: 1681,
        settings: {
          centerPadding: "10.61rem",
        },
      },
      {
        breakpoint: 1281,
        settings: {
          centerPadding: "10rem",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "8.1rem",
        },
      },
      {
        breakpoint: 601,
        settings: {
          centerPadding: "3.286rem",
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".banner-slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "linear",
    autoplay: false,
    speed: 1500,
    autoplaySpeed: 3000,
    dots: true, // Enable dots
    arrows: true,
    rtl: isRTL,
    prevArrow: $(".banner-prev"),
    nextArrow: $(".banner-next"),
    appendDots: $(".banner-dots"), // Optional custom container
  });
});

function cultureSlider() {
  const remToPx = (rem) => rem * parseFloat($("html").css("font-size"));
  let sliderInitialized = false;

  function initSlider() {
    if ($(".js-cultureSlider").hasClass("slick-initialized")) {
      $(".js-cultureSlider").slick("unslick");
    }

    $(".js-cultureSlider").on("init", function (event, slick) {
      setTimeout(function () {
        var dotsWidth = $(".culture-dots").width() + 8;
        $(".culture-dots").css("width", dotsWidth + "px");
      }, 50);
    });

    $(".js-cultureSlider").slick({
      infinite: false,
      slidesToShow:
        window.innerWidth >= 992 ? 4 : window.innerWidth >= 600 ? 2 : 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      rtl: isRTL,
      dots: true,
      appendDots: $(".culture-dots"),
      prevArrow: $(".cultureSlider-prev"),
      nextArrow: $(".cultureSlider-next"),
    });

    $(".js-cultureSlider .card .card-body").css("display", "");

    let maxHeight = 0;
    $(".js-cultureSlider .card").each(function () {
      const cardHeight =
        window.innerWidth >= 600
          ? $(this).outerHeight(true)
          : $(this).find(".para").outerHeight(true);
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });

    if (window.innerWidth >= 600) {
      $(".js-cultureSlider").css("height", maxHeight + remToPx(3) + "px");
      $(".js-cultureSlider .card:not(.active) .card-body").css(
        "display",
        "none"
      );
    } else {
      $(".js-cultureSlider .card-body p").css("height", maxHeight + "px");
    }

    sliderInitialized = true;
  }

  initSlider();

  let resizeTimer;
  let lastWindowWidth = $(window).width();

  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      let currentWindowWidth = $(window).width();

      if (sliderInitialized && currentWindowWidth !== lastWindowWidth) {
        lastWindowWidth = currentWindowWidth; // Update stored width
        initSlider(); // Reinitialize only if width changed
      }
    }, 250); // Debounce delay
  });
}

$(document).ready(function () {
  // player.once("ready", () => {
  //   player.play().catch((error) => {
  //     console.log("Autoplay failed:", error);
  //   });
  // });

  // $("#posterContainer").on("click", function () {
  // $(this).fadeOut(0, function () {
  //   $('#actualVideo').css('display', 'block').addClass('fade-in');
  // Optional: Add event listeners for player events if needed //
  // player.on('play', () => {
  //     console.log('Video started playing');
  // });
  // player.on('pause', () => {
  //     console.log('Video paused');
  // });
  // player.on('ended', () => {
  //     console.log('Video ended');
  //     // Optional: handle end state
  // });
  // });
  // });
  let bannerVideoCompleted;
  const pageLanguage = document.documentElement.getAttribute("lang");
  if ($(".banner-video").length > 0) {
    const videoElement = $(".banner-video")[0];
    videoElement.addEventListener("ended", function () {
      this.currentTime = 0;
      this.play();
    });
    const videoTitle = videoElement.getAttribute("video-title");
    videoElement.addEventListener("timeupdate", function () {
      const percentPlayed =
        (Math.ceil(this.currentTime) / Math.ceil(this.duration)) * 100;
      if (bannerVideoCompleted) return;
      if (percentPlayed >= 100) {
        bannerVideoCompleted = true;
      }
      window.dataLayer.push({
        custom_event_name: "video",
        event: "eventTracker",
        video_status:
          Math.floor(this.currentTime) === Math.floor(this.duration)
            ? "complete"
            : "progress",
        video_percent: percentPlayed,
        video_duration: this.duration,
        video_url: this.querySelector("source").src,
        video_language: pageLanguage,
        video_title: videoTitle,
      });
    });
  }

  // Ensure poster video loops
  let hasCompleted = false;

  if ($(".poster-video").length > 0) {
    const posterVideoElement = $(".poster-video")[0];

    posterVideoElement.addEventListener("ended", function () {
      this.currentTime = 0;
      this.play();
    });
    const videoTitle = posterVideoElement.getAttribute("video-title");

    posterVideoElement.addEventListener("timeupdate", function () {
      const percentPlayed =
        (Math.ceil(this.currentTime) / Math.ceil(this.duration)) * 100;
      if (hasCompleted) return;
      if (percentPlayed >= 100) {
        hasCompleted = true;
      }
      window.dataLayer.push({
        custom_event_name: "video",
        event: "eventTracker",
        video_status:
          Math.floor(this.currentTime) === Math.floor(this.duration)
            ? "complete"
            : "progress",
        video_percent: percentPlayed,
        video_duration: this.duration,
        video_url: this.querySelector("source").src,
        video_language: pageLanguage,
        video_title: videoTitle,
      });
    });
  }
});

function menuOpen() {
  $(".hamburger").on("click", function () {
    $("html").toggleClass("menu--open");
    toggleScroll();
  });
  $(".lang-switch").on("click", function (e) {
    e.stopPropagation(); // Prevent the event from bubbling up to the document
    $(this).toggleClass("lang_open");
  });

  $(document).on("click", function (e) {
    // If the click is not inside .lang-switch
    if (!$(e.target).closest(".lang-switch").length) {
      $(".lang-switch").removeClass("lang_open");
    }
  });
}

// function scrollTop() {
//   var lastScrollTop = 0;
//   $(window).scroll(function () {
//     var st = $(this).scrollTop();
//     if (st > lastScrollTop) {
//       $("body").removeClass("scrollTop");
//       $("body").addClass("bodyScrolled");
//     } else {
//       $("body").addClass("scrollTop");
//       $("body").removeClass("bodyScrolled");
//     }
//     if (st === 0) {
//       $("body").removeClass("scrollTop");
//       $("body").removeClass("bodyScrolled");
//     }

//     lastScrollTop = st;
//   });
// }
function scrollTop() {
  var lastScrollTop = 0;
  var threshold = 100;

  $(window).scroll(function () {
    var st = $(this).scrollTop();

    // At the top of the page — handle first
    if (st === 0) {
      $("body").removeClass("scrollTop bodyScrolled");
      lastScrollTop = 0; // Reset scroll position
      return;
    }

    // Ignore small scroll changes
    if (Math.abs(st - lastScrollTop) <= threshold) return;

    if (st > lastScrollTop) {
      // Scrolling down
      $("body").removeClass("scrollTop").addClass("bodyScrolled");
    } else {
      // Scrolling up
      $("body").addClass("scrollTop").removeClass("bodyScrolled");
    }

    lastScrollTop = st;
  });
}

let isTouchDevice = false;
let isMouseDevice = false;

function detectPointerType() {
  if (window.matchMedia("(pointer: coarse)").matches) {
    isTouchDevice = true;
    isMouseDevice = false;
  } else if (window.matchMedia("(pointer: fine)").matches) {
    isTouchDevice = false;
    isMouseDevice = true;
  } else {
    isTouchDevice = false;
    isMouseDevice = false;
  }
  // console.log("Touch:", isTouchDevice, "Mouse:", isMouseDevice);
}
window.addEventListener("resize", detectPointerType);

function revealAnimation() {
  gsap.registerPlugin(ScrollTrigger);

  $(".reveal-animation").each(function () {
    const $container = $(this);
    const $element = $container.find(".reveal-text").first();

    // Use SplitType on the native DOM element, not jQuery object
    const split = new SplitType($element[0], { types: "lines" });

    // Wrap lines
    split.lines.forEach((line) => {
      const $line = $(line);

      const $outer = $("<span>").css({
        display: "block",
        position: "relative",
      });

      const bgColor = $element.data("bg-color"); // use jQuery data()

      const $bg = $("<span>")
        .css({
          display: "block",
          position: "relative",
          color: bgColor,
        })
        .html($line.html());

      const $fg = $("<span>").addClass("clip-text").html($line.html());

      $bg.append($fg);
      $outer.append($bg);
      $line.replaceWith($outer);
    });

    const $lines = $container.find(".clip-text");

    gsap.set($lines.toArray(), {
      clipPath: "inset(0% 0% 100% 0%)",
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $container[0],
        start: "top 70%",
        end: "bottom 50%",
        scrub: true,
        markers: false,
      },
    });

    tl.to($lines.toArray(), {
      clipPath: "inset(0% 0% -10% 0%)",
      stagger: 0.3,
    });
  });
}

function stickVideoAnimation() {
  gsap.registerPlugin(ScrollTrigger);
  let totalScroll = 1500;
  const video = $(".stick-video-animation");
  const section = $(".video-stick-section");

  ScrollTrigger.matchMedia({
    "(min-width: 992px)": function () {
      const totalScroll = 1500;

      gsap.fromTo(
        video,
        {
          scale: 0.6,
        },
        {
          scale: 1,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 70vh",
            end: `+=1000`,
            scrub: true,
            // markers: true,
          },
        }
      );

      ScrollTrigger.create({
        trigger: section,
        start: "top 5%",
        end: `+=${totalScroll}`,
        pin: true,
        anticipatePin: 1,
        scrub: false,
      });
    },
  });
}


function observeVideoPause() {
  let player;
  const isMobile = window.innerWidth < 992;

  $("#posterContainer").on("click", function () {
    $(this).fadeOut(0, function () {
      $("#actualVideo").css("display", "block").addClass("fade-in");

      player = new Plyr("#actualVideo", {
        autoplay: false,
        // fullscreen: { enabled: false },
        loop: {
          active: true,
        },
        hideControls: false,
        controls: [
          "play-large",
          "play",
          "mute",
          "fullscreen",
          ...(isMobile ? ["fullscreen"] : []),
          // "volume",
          // 'progress',
          // 'current-time',
          // 'duration',
          // 'settings',
        ],
        settings: ["quality", "speed"],
        quality: {
          default: 720,
          options: [1080, 720, 480, 360],
        },
        fullscreen: {
          enabled: isMobile, // Enable fullscreen only if < 991px
        },
      });

      player.once("ready", () => {
        player.play().catch((error) => {
          console.log("Autoplay failed:", error);
        });
      });

      // Optional: Add event listeners for player events if needed //

      // player.on('play', () => {
      //     console.log('Video started playing');
      // });

      // player.on('pause', () => {
      //     console.log('Video paused');
      // });

      // player.on('ended', () => {
      //     console.log('Video ended');
      //     // Optional: handle end state
      // });
    });
  });

  const videoSection = document.querySelector(".video-stick-section");

  // Create IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Optional: player.play(); // auto-play when visible
        } else {
          // console.log("Video is out of view");
          player?.pause(); // pause when not visible
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0.3, // 30% of video needs to be visible
    }
  );

  // Observe the section
  if (videoSection) {
    observer.observe(videoSection);
  }
}

let lenis;
let isScrollPaused = false;
function initSmoothScroll() {
  lenis = new Lenis({
    duration: 2.5,
    easing: (t) => 1 - Math.pow(1 - t, 3.5),
    smooth: true,
    smoothTouch: true,
    direction: "vertical",
    gestureDirection: "vertical",
  });

  function raf(time) {
    if (!isScrollPaused) {
      lenis.raf(time);
    }
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
}

function stopScroll() {
  if (!isScrollPaused) {
    isScrollPaused = true;
    lenis.stop();
    document.body.classList.add("scroll-paused");
  }
}

function startScroll() {
  if (isScrollPaused) {
    isScrollPaused = false;
    lenis.start();
    document.body.classList.remove("scroll-paused");
  }
}

function toggleScroll() {
  isScrollPaused ? startScroll() : stopScroll();
}

// Two COl Slider
function twoColSlider(loop = true, autoplay = false, delay = 5000) {
  $(".thm-two-col-slider-wrapper.slider").each(function () {
    const $wrapper = $(this);
    const $templates = $wrapper.find(".slide-templates .slide-data");
    const $slider = $wrapper.find(".slide-img");
    const $heading5 = $wrapper.find(".slider-subtitle");
    const $heading2 = $wrapper.find(".slider-maintitle");
    const $para = $wrapper.find(".caption-wrapper");
    const $contentWrapper = $wrapper.find(".main-content");
    let startX, endX;

    $slider.empty();

    $slider.on("init", function (event, slick) {
      setTimeout(function () {
        var dotsWidth = $(".twoCol-dots").width() + 8;
        $(".twoCol-dots").css("width", dotsWidth + "px");
      }, 50);

      const $prev = $wrapper.find(".slider-prev");
      const $next = $wrapper.find(".slider-next");

      $prev.removeClass("active").addClass("disabled");
      $next.removeClass("disabled").addClass("active");
    });
    $templates.each(function () {
      const $data = $(this);
      const image = $data.data("image");
      const title = $data.find("h2").text();
      const subtitle = $data.find("h5").text();
      const captionHTML = $data.find(".para").html();

      const $slide = $(`
          <div class="slide-item" 
               data-title="${title}" 
               data-subtitle="${subtitle}" 
               data-caption='${captionHTML.replace(/'/g, "&apos;")}'>
            <img src="${image}" alt="" style="width: 100%; object-fit: cover;"  data-aos="fade-left" data-aos-duration="600" data-aos-delay="0" data-aos-once="true"/>
          </div>
        `);

      $slider.append($slide);
    });
    if (!($templates.length <= 1)) {
      $slider.slick({
        infinite: loop,
        autoplay: autoplay,
        autoplaySpeed: delay,
        fade: false,
        arrows: true,
        prevArrow: $wrapper.find(".slider-prev"),
        nextArrow: $wrapper.find(".slider-next"),
        dots: true,
        appendDots: $wrapper.find(".twoCol-dots"),
        speed: 700,
        rtl: isRTL,
        cssEase: "ease-in-out",
      });
    }
    function updateCaptions(index) {
      $contentWrapper.removeClass("animate");
      const $active = $slider.find(".slide-item").eq(index);
      $heading2.text($active.data("title"));
      $heading5.text($active.data("subtitle"));
      $para.html($active.data("caption"));
      setTimeout(function () {
        $contentWrapper.addClass("animate");
      }, 0);
    }
    updateCaptions(0);
    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        updateCaptions(nextSlide);

        const $prev = $wrapper.find(".slider-prev");
        const $next = $wrapper.find(".slider-next");

        $prev.removeClass("disabled active");
        $next.removeClass("disabled active");

        $prev.addClass("active");
        $next.addClass("active");

        if (nextSlide === 0) {
          $prev.addClass("disabled");
        }
        if (nextSlide === slick.slideCount - 1) {
          $next.addClass("disabled");
        }
      }
    );

    $contentWrapper.on("touchstart", function (e) {
      startX = e.originalEvent.touches[0].clientX;
    });

    $contentWrapper.on("touchend", function (e) {
      endX = e.originalEvent.changedTouches[0].clientX;
      handleSwipe();
    });

    function handleSwipe() {
      let diff = endX - startX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  });
}

// Cookies Function Starts //
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

function showCookie() {
  if (!getCookie("cookiesAccepted")) {
    $("#cookieBanner").fadeIn();
    $("body , html").addClass("cookieVisible");
    toggleScroll();
  }

  $("#allowCookies").click(function () {
    setCookie("cookiesAccepted", "true", 30);
    $("#cookieBanner").fadeOut();
    $("body , html").removeClass("cookieVisible");
    toggleScroll();
  });

  $("#declineCookies").click(function () {
    $("#cookieBanner").fadeOut();
    $("body , html").removeClass("cookieVisible");
    toggleScroll();
  });
}
// Cookies Function Ends //

// culture card //
function updateCardState() {
  const cards = document.querySelectorAll(".card");

  if (window.innerWidth < 600) {
    // Mobile: All cards open
    cards.forEach((card) => card.classList.add("active"));
  } else {
    // Desktop: Only one card should be active
    let activeFound = false;

    cards.forEach((card) => {
      if (!activeFound && card.classList.contains("active")) {
        activeFound = true;
      } else {
        card.classList.remove("active");
      }
    });

    // If no card was active, activate the first one
    if (!activeFound && cards.length > 0) {
      cards[0].classList.add("active");
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll(".input-field");

  inputs.forEach((input) => {
    const label = input.parentElement.querySelector("label");


    const toggleLabel = () => {
      if (label) {
        if (input.value.trim() !== "" || document.activeElement === input) {
          label?.classList.add("hidden");
        } else {
          label?.classList.remove("hidden");
        }
      }
    };

    // On load
    toggleLabel();

    // Events
    input.addEventListener("focus", toggleLabel);
    input.addEventListener("blur", toggleLabel);
    input.addEventListener("input", toggleLabel);
  });
});

$(document).ready(function () {
  function updateCardBehavior() {
    const isMobile = $(window).width() <= 600;
    if (isMobile) {
      $(".slick-slide").off("click");
      $(".card").addClass("active");
    } else {
      $(".card").removeClass("active");
      $(".slick-slide.slick-active.slick-current")
        .find(".card")
        .addClass("active");

      $(".js-cultureSlider .slick-slide")
        .off("click")
        .on("click", function () {
          $(".card").removeClass("active");
          if ($(this).find(".card").hasClass("open")) {
            // if ($(this).find('.card').hasClass('open')) {
            $(this).find(".card").addClass("active");
          }
        });
    }
  }

  $(".js-cultureSlider").on("init", function (event, slick) {
    updateCardBehavior();
  });

  $(".js-cultureSlider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      const isMobile = $(window).width() <= 600;

      if (isMobile) {
        $(".card").addClass("active");
      } else {
        const $activeSlides = $(".slick-slide.slick-active");
        const anyActiveCard = $activeSlides.find(".card.active").length > 0;

        if (!anyActiveCard) {
          $(".card").removeClass("active");
          $(".card").find(".card-body").slideUp();
          $(".slick-slide.slick-current.slick-active")
            .find(".card")
            .addClass("active");
          $(".slick-slide.slick-current.slick-active")
            .find(".card-body")
            .slideDown();
        }
      }
    }
  );

  $(window).on("load", function () {
    updateCardBehavior();
  });
});

function scrollToSection(selector) {
  const $target = $(selector);
  if ($target.length) {
    lenis.scrollTo($target[0]);
  }
}
//
$(document).ready(function () {
  const scrollTarget = sessionStorage.getItem("scrollToTarget");
  if (scrollTarget) {
    setTimeout(function () {
      const targetElement = document.querySelector(scrollTarget);
      if (targetElement) {
        lenis.scrollTo(targetElement);
      }
      sessionStorage.removeItem("scrollToTarget");
    }, 1000);
  }
});

$(".socialWrapper a").on("click", function () {
  const socialTag = $(this).attr("social-tag-name");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "eventTracker",
    custom_event_name: "social_link_clicks",
    social_tag_name: socialTag,
  });
});

$(".social--wrapper a").on("click", function () {
  const socialTag = $(this).attr("social-tag-name");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "eventTracker",
    custom_event_name: "social_link_clicks",
    social_tag_name: socialTag,
  });
});

$("#js-toScroll-section a[data-toScroll]").on("click", function (e) {
  e.preventDefault();

  if ($("html").hasClass("menu--open")) {
    $("html").toggleClass("menu--open");
    toggleScroll();
  }

  const SiteLang = window.customVariables.SiteLang
    ? window.customVariables.SiteLang
    : ["en", "ar"];
  let rawPath = $(this).data("toscroll");
  if (!rawPath) return;

  let cleaned = rawPath.replace(/^\//, "");
  let segments = cleaned.split("/");

  let newPath = "";
  let scrollTo = "";

  if (segments.length > 1) {
    newPath =
      segments[0] === "*" ? window.location.pathname : `/${segments[0]}`;
    scrollTo = `#${segments[1]}`;
  } else {
    newPath = "/";
    scrollTo = `#${segments[0]}`;
  }

  sessionStorage.setItem("scrollToTarget", scrollTo);

  let currentPath = window.location.pathname;
  let currentSegments = currentPath.split("/");
  let langPrefix = SiteLang.includes(currentSegments[1])
    ? `/${currentSegments[1]}`
    : "";

  if (segments[0] === "*") {
    const targetElement = document.querySelector(scrollTo);
    if (targetElement) {
      lenis.scrollTo(targetElement);
      sessionStorage.removeItem("scrollToTarget");
    }
  } else {
    let destinationPath = langPrefix ? `${langPrefix}${newPath}` : newPath;

    let currentBasePath = currentPath.replace(/#.*$/, "");
    let destinationBasePath = destinationPath.replace(/#.*$/, "");

    if (currentBasePath === destinationBasePath) {
      const targetElement = document.querySelector(scrollTo);
      if (targetElement) {
        lenis.scrollTo(targetElement);
        sessionStorage.removeItem("scrollToTarget");
      }
    } else {
      window.location.href = destinationPath;
    }
  }

  const menuItemText = $(this).find("span").first().text();
  window.dataLayer.push({
    event: "eventTracker",
    custom_event_name: "navigation_main",
    navigation_cta_name: menuItemText,
  });
});

// ---------------- Footer ---------------- //

const input = document.querySelector("#submitterNationality");
const label = input.parentElement.querySelector("label");

const toggleLabel = () => {
  if (label) {
    if (input.value.trim() !== "" || document.activeElement === input) {
      label?.classList.add("hidden");
    } else {
      label?.classList.remove("hidden");
    }
  }
};

// For Initialization

$("#submitterNationality")
  ?.select2({
    placeholder: "Country",
    allowClear: false,
    // dropdownParent: $('#submitterNationality').parent() // Or a closer wrapper div
  })
  .on("select2:open", function () {
    setTimeout(function () {
      $(".select2-results__options").mCustomScrollbar({
        axis: "y",
        theme: "dark",
        scrollInertia: 300,
        scrollbarPosition: "inside",
        autoHideScrollbar: true,
      });
    }, 0);
  })
  .on("select2:close", () => {
    $(".submitter-details").mCustomScrollbar("update");
  })
  .on("select2:select select2:unselect", () => {
    toggleLabel(); // <-- call label toggle on select or unselect
  });

// on Close
$("#submitterNationality")?.on("select2:close", function () {
  $(".submitter-details").mCustomScrollbar("update"); // or "enable" if needed
});

// / Disable on dropdown open
$("#submitterNationality").on("select2:open", function () {
  // $(".submitter-details").mCustomScrollbar("disable");
  $(".select2-results__options").mCustomScrollbar("destroy");
});
toggleLabel();


function checkIOS() {
  var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  // var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (isIOS) {
    $('html').addClass('ios-device'); // or use $('body') if preferred
  }
}
